import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const OpenPositions = ({ jobs }) => {
  const navigate = useNavigate();
  const [showAll, setShowAll] = useState(false);
  const displayedJobs = showAll ? jobs : jobs?.slice(0, 6);

  const handleApplyJob = (jobId) => {
    navigate('/job-application', { state: { jobId } });
  };

  const handleViewDetails = (jobId) => {
    navigate('/job-details', { state: { jobId } });
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6 lg:p-8">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-bold text-foreground">Open Positions ({jobs?.length})</h2>
        <Button variant="outline" iconName="Bell" iconPosition="left">
          Job Alerts
        </Button>
      </div>
      <div className="space-y-4">
        {displayedJobs?.map((job) => (
          <div
            key={job?.id}
            className="p-6 bg-muted/50 border border-border rounded-lg hover:border-primary/50 transition-smooth"
          >
            <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4">
              <div className="flex-1">
                <div className="flex items-start gap-3 mb-3">
                  <h3 className="text-lg font-semibold text-foreground hover:text-primary cursor-pointer transition-smooth">
                    {job?.title}
                  </h3>
                  {job?.featured && (
                    <span className="px-2 py-1 bg-accent text-accent-foreground text-xs font-medium rounded">
                      Featured
                    </span>
                  )}
                </div>

                <div className="flex flex-wrap items-center gap-4 text-sm text-muted-foreground mb-3">
                  <div className="flex items-center gap-2">
                    <Icon name="MapPin" size={16} />
                    <span>{job?.location}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Icon name="Briefcase" size={16} />
                    <span>{job?.experience}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Icon name="IndianRupee" size={16} />
                    <span>{job?.salary}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Icon name="Clock" size={16} />
                    <span>{job?.type}</span>
                  </div>
                </div>

                <div className="flex flex-wrap gap-2">
                  {job?.skills?.map((skill, index) => (
                    <span
                      key={index}
                      className="px-3 py-1 bg-primary/10 text-primary text-xs font-medium rounded-full"
                    >
                      {skill}
                    </span>
                  ))}
                </div>
              </div>

              <div className="flex items-center gap-3 lg:flex-col lg:items-stretch">
                <Button
                  variant="default"
                  onClick={() => handleApplyJob(job?.id)}
                  iconName="Send"
                  iconPosition="left"
                  className="flex-1 lg:flex-none"
                >
                  Apply Now
                </Button>
                <Button
                  variant="outline"
                  onClick={() => handleViewDetails(job?.id)}
                  className="flex-1 lg:flex-none"
                >
                  View Details
                </Button>
              </div>
            </div>

            <div className="mt-4 pt-4 border-t border-border flex items-center justify-between text-sm text-muted-foreground">
              <span>Posted {job?.postedDate}</span>
              <span>{job?.applicants} applicants</span>
            </div>
          </div>
        ))}
      </div>
      {jobs?.length > 6 && (
        <div className="mt-6 text-center">
          <Button
            variant="outline"
            onClick={() => setShowAll(!showAll)}
            iconName={showAll ? "ChevronUp" : "ChevronDown"}
            iconPosition="right"
          >
            {showAll ? "Show Less" : `View All ${jobs?.length} Positions`}
          </Button>
        </div>
      )}
    </div>
  );
};

export default OpenPositions;